import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/interfaces/base-entity';
import {
  SaveEppIntegrationConfigCommand,
  EppIntegrationConfig,
  EppIntegrationLogsRequest,
  EppIntegrationLogsResponse,
  EppPlaceholder
} from '../models/epp-integration.models';

@Injectable({
  providedIn: 'root'
})
export class EppIntegrationService {
  private baseUrl = `${environment.host}/api/EppIntegrationConfig`;

  constructor(private http: HttpClient) {}

  save(command: SaveEppIntegrationConfigCommand): Observable<ApiResponse<EppIntegrationConfig>> {
    return this.http.post<ApiResponse<EppIntegrationConfig>>(`${this.baseUrl}/save`, command);
  }

  getByCompany(companyId: number): Observable<ApiResponse<EppIntegrationConfig[]>> {
    return this.http.get<ApiResponse<EppIntegrationConfig[]>>(`${this.baseUrl}/byCompany/${companyId}`);
  }

  delete(id: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.baseUrl}/delete/${id}`);
  }

  retry(syncLogId: number): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.baseUrl}/retry/${syncLogId}`, {});
  }

  getLogs(request: EppIntegrationLogsRequest): Observable<ApiResponse<EppIntegrationLogsResponse>> {
    return this.http.post<ApiResponse<EppIntegrationLogsResponse>>(`${this.baseUrl}/logs`, request);
  }

  getAvailablePlaceholders(): Observable<EppPlaceholder[]> {
    return this.http.get<EppPlaceholder[]>(`${this.baseUrl}/available-placeholders`);
  }
}
